import { lumi } from '@/lib/lumi'

function getSessionId(): string {
  if (typeof window === 'undefined') return 'ssr'
  let sid = window.sessionStorage.getItem('cs_session_id')
  if (!sid) {
    sid = `s_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`
    window.sessionStorage.setItem('cs_session_id', sid)
  }
  return sid
}

export type AnalyticsEvent =
  | 'page_view'
  | 'calculator_use'
  | 'cta_click'
  | 'blog_read'
  | 'contact_submit'

export async function track(
  eventType: AnalyticsEvent,
  pagePath: string,
  metadata?: Record<string, unknown>,
) {
  if (typeof window === 'undefined') return
  try {
    const payload: Record<string, unknown> = {
      eventType,
      pagePath,
      pageTitle: document.title,
      sessionId: getSessionId(),
      userAgent: navigator.userAgent,
      referrer: document.referrer || '',
      createdAt: new Date().toISOString(),
    }
    if (metadata) payload.metadata = metadata
    await lumi.entities.page_analytics.create(payload)
  } catch (error) {
    console.warn('analytics track failed:', error)
  }
}
